// The USD per unit amount. Currently points per day is the rate per usd per $1000
export const BASE_PPS = 0.0005; //FALLBACK VALUE
export const BASE_REFERRAL_PPS = 0;
